// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2Zezf";
var _4 = "gdsTotalPrice-3n4MJ";
var _5 = "form-3rgOv";
var _6 = "passengersToolbar__label-2yWuD";
var _7 = "checkoutServices-2mVaU";
var _8 = "summary__header-rPb4U";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "gdsTotalPrice", _5 as "form", _6 as "passengersToolbar__label", _7 as "checkoutServices", _8 as "summary__header" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "gdsTotalPrice": _4, "form": _5, "passengersToolbar__label": _6, "checkoutServices": _7, "summary__header": _8 }
